import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import React__default from 'react';
import cx from 'classnames';

var _excluded = ["children", "className"];

var IconElement = /*#__PURE__*/_styled("span", {
  target: "exd7dve0"
})({
  name: "ft61yw",
  styles: "width:1rem;height:1rem;> svg{width:100%;height:100%;}"
});

var Icon = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var combinedClassName = cx("vds-icon", "bp3-icon", className);
  return /*#__PURE__*/React__default.createElement(IconElement, _extends({
    ref: ref,
    className: combinedClassName
  }, props), children);
});

export { Icon };
//# sourceMappingURL=icon.js.map
